import pLimit from "p-limit";
import DashboardTopN from "./dashboardtopn";
import DashboardQuery from "./dashboardquery"
import DetailsQuery from "./detailsquery"
import KPITimeSeries from "./kpitimeseries";


function getContentBoxs(node) {
    let boxes = [];
    let parentContentBox = node.closest(".content-box")
    if (parentContentBox != null)
        boxes.push(parentContentBox);

    // KIPs need to search down the tree, and there will be multiple
    Array
        .from(node.parentNode.querySelectorAll(".kpi-box"))
        .forEach((el) => {
            boxes.push(el);
        });

    return boxes;
}


function load() {
    const items = Array.from(document.querySelectorAll("script[type^='api/']"));

    // only allow 3 charts to load at a time
    const limit = pLimit(3);
    let tasks = [];

    // the loader works by finding script elements with type="api/..."
    items.forEach((scriptElement) => {

        // get content boxes so we can fade them out while data  is loading
        let contextBoxes = getContentBoxs(scriptElement);
        function resetOpacity(opacity) {
            opacity = opacity||"100%";
            contextBoxes.forEach(el => {
               el.style.opacity = opacity;

               if (opacity === "100%") {
                   let chartLoading = el.querySelector(".chart-loading");
                   if (chartLoading != null) {
                       chartLoading.style.display = "none";
                   }
               }
            });
        }

        resetOpacity("25%");

        const type = scriptElement.getAttribute("type");
        if (type === "api/dashboard-topn") {
            tasks.push(limit(() => {
                return DashboardTopN
                    .loadFromDomScript(scriptElement)
                    .then(resetOpacity);
            }));
        } else if (type === "api/dashboard-query") {
            tasks.push(limit(() => {
                return DashboardQuery
                    .loadFromDomScript(scriptElement)
                    .then(resetOpacity)
            }));
        } else if (type === "api/details-query") {
            tasks.push(limit(() => {
                return DetailsQuery
                    .loadFromDomScript(scriptElement)
                    .then(resetOpacity)
            }));
        } else if (type === "api/kpi-timeseries") {
            tasks.push(limit(() => {
                return KPITimeSeries
                    .loadFromDomScript(scriptElement)
                    .then(resetOpacity)
            }));
        }
    });

    Promise.all(tasks);
}



const ChartLoader = {
    "load": function () {
        load();
    }
};

export default ChartLoader;